import { Box } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { getMe, signinWithFirebaseCustomToken } from "@services/auth";
import { SectionContainer, Title } from "../../styled/StyledComponents";
import SubmitButton from "../../submit-button/SubmitButton";
import { authStorage } from "@services/authStorage";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "@reducers/auth";
import { useRouter } from "next/router";
import { AmptitudeEvents } from "@services/amptitude_events";
import { VERIFICATION_COMPLETED } from "@services/amptitude_contants";
export default function SuccessfulVerification({
  isClickedSmsVerifyButton,
  userData,
}) {
  const dispatch = useDispatch();
  const router = useRouter();

  const verifyEvent = async () => {
    const amptitudeResponse = await AmptitudeEvents(
      "User Registration",
      userData?.id,
      VERIFICATION_COMPLETED,
      isClickedSmsVerifyButton ? "SMS" : "EMAIL"
    );
    router.replace("/login");
  };

  return (
    <SectionContainer style={{width:"500px"}} height="712px">
      <Box  className="flex-center p-5 " height="100%" marginTop="95px">
        <Title>You are registered on FruPro!</Title>
      </Box>
      <SubmitButton fontSize="24px" onClick={verifyEvent}>
        Login to continue
      </SubmitButton>
    </SectionContainer>
  );
}
